import { render, staticRenderFns } from "./SearchCompList.vue?vue&type=template&id=12a8ff9c&scoped=true"
import script from "./SearchCompList.vue?vue&type=script&lang=js"
export * from "./SearchCompList.vue?vue&type=script&lang=js"
import style0 from "./SearchCompList.vue?vue&type=style&index=0&id=12a8ff9c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a8ff9c",
  null
  
)

export default component.exports